 <template>
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters"  size="mini">
				<el-form-item label="项目名称">
					<el-select v-model="filters.projectId" @change="getDevices" filterable>
						<el-option
							v-for="item in projects"
							:label="item.name"
							:value="item.projectId" :key="item.projectId">
						</el-option >
					</el-select>
				</el-form-item>
				<el-form-item label="点位名称" >
					<el-select v-model="filters.mn" filterable>
						<el-option
							v-for="item in devices"
							:label="item.name"
							:value="item.mnCode" :key="item.mnCode">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="设备编码"  v-if="type==0">
					<el-select v-model="filters.mn" filterable>
						<el-option
							v-for="item in devices"
							:label="item.mnCode"
							:value="item.mnCode" :key="item.mnCode">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="时间">
					<el-date-picker v-model="filters.time" type="daterange"  value-format="yyyy-MM-dd"> </el-date-picker>
                </el-form-item>
                
				<el-form-item>
					<my-button  @select-type="clickBtn" QueryButtonShow></my-button>
				</el-form-item>
			</el-form>
		</el-col>

		<el-table :data="dataList" border  highlight-current-row v-loading="listLoading" style="width: 100%;" :height="formHeight" 
		@selection-change="selsChange"  size="small" >
			<el-table-column   type="selection"   width="55">   </el-table-column>
			<el-table-column type="index" label="序号"  ></el-table-column>
			<!-- <el-table-column prop="Date" label="MN" width="160" ></el-table-column> -->
			<el-table-column prop="starttime" label="时间"  sortable  ></el-table-column>
            <el-table-column   label="异常噪声"  >
                <template slot-scope="scope">
                    <audio :src="scope.row.src" controls="controls"></audio>
				</template>
            </el-table-column>
			<el-table-column prop="noisesource" label="声源识别">
				<template slot-scope="scope">
					<span v-if="scope.row.noisesource==null||scope.row.noisesource==''">待识别</span>
					<span v-else >{{scope.row.noisesource}}</span>
				</template>
			</el-table-column>
			<el-table-column label="操作">
				<template slot-scope="scope">
					<!-- <el-button size="small" @click="showBar(scope.$index, scope.row)">查看频谱</el-button> -->
					<table-update-button   @select-type="handleIdent(scope.$index, scope.row)" btnCon="手动识别">  </table-update-button>
					<table-update-button   @select-type="showIdent(scope.$index, scope.row)" btnCon="人工标记">  </table-update-button>
				</template>
			</el-table-column>
			<!-- <el-table-column  label="声源定位">
               <template slot-scope="scope">
                    <el-image   style="width: 30px; height: 16px;"  src="/static/query.png"   :preview-src-list="srcList">  </el-image>
                </template>
			</el-table-column> -->
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<edit-button  @select-type="handleIdent" btnCon="批量识别" :disabled="this.sels.length===0"></edit-button>
			<el-pagination layout="total, sizes, prev, pager, next, jumper" @current-change="handleCurrentChange" :page-size="pageSize" :total="total" style="float:right;"
			 :page-sizes="[ 10, 20, 30,40,50]"   @size-change="handleSizeChange" :current-page.sync="page"></el-pagination>
		</el-col>

		<el-dialog title="频谱数据查看" :visible.sync="formVisible" id="dialog"  top="8vh" :close-on-click-modal="false">
			<div style="width:100%;height:100%"  id="noiseSpectrum"  ></div>
		</el-dialog>

		<el-dialog title="人工标记" :visible.sync="soundVisible" top="8vh"  :close-on-click-modal="false">
			<div >
				<el-select  v-model="soundValue"  filterable  default-first-option  placeholder="请选择声音类别">
					<el-option v-for="item in soundList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
				</el-select>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="cancleSubmit">取消</el-button>
				<el-button type="primary" @click.native="addSubmit">提交</el-button>
			</div>
		</el-dialog>

	</section>
</template>

<script>
	import { getProjects,getDevicesByProjectId,queryNoiseRecording,getFactorNoise,
		getNoiseSpectrum,handleIdent,getSoundTypeList,peopleIdent} from '../../api/api';
	import {formatDateDay,pad2} from '../../../static/fun.js';
	import * as echarts from "echarts";

	import myButton from '../../components/myButton/index.vue'
	import TableUpdateButton from '../../components/myButton/TableUpdateButton.vue'
	import EditButton from '../../components/myButton/EditButton.vue'

	export default {
	components: { myButton,TableUpdateButton,EditButton },
		data() {
			return {
				filters: {
					projectId:"",
					mn:"",
                    time:[]
				},
				total: 0,
				page:1,
				pageSize:10,
				listLoading: false,
				dataList:[],
				firstFlag:true,
				devices:[],
				projects:[],
				formHeight:0,
                timeType:'1',
                type:sessionStorage.getItem("type"),
                userId:sessionStorage.getItem("userId"),
				formVisible:false,
				charts:null,

				factorMap:new Map(),
				facList:[],
				choosemn:"",
				sels:[],
				soundList:[],
				soundVisible:false,
				chooseSound:{},
				soundValue:'',
				srcList: [ 'http://localhost:8083/static/1.jpg']
			}
			
		},
		methods: {
			clickBtn(type){
				if(type=="query"){
					this.getDataList();
				}
			},
			selsChange: function (sels) {
				this.sels = sels;
			},
			handleIdent(i,row){
				var obj=[];
				if(row!=undefined){
					obj.push(row);
				}else{
					obj=this.sels;
				}
				//开始手动识别
				var _this=this;
				this.listLoading=true;
				handleIdent(obj).then((res) => {
					this.listLoading=false;
					if(res.data.result=="true"||res.data.result==true){
						this.$message({
                            message: "操作成功",
                            type: 'success'
                        })
						this.getDataList();
					}else{
						this.$message({
							message: "操作失败，请重试",
							type: 'error'
						})
					}
				}).catch(function(err) {
					_this.listLoading=false;
					_this.$message({
						message: "操作失败，请重试",
						type: 'error'
					})
					console.log(err);
				});
			},
			showIdent(i,row){
				this.getSoundList();
				this.chooseSound=row;
				this.soundVisible=true;
			},
			getFactorNoise(row){ 
				if(this.factorMap.size>0){
					this.getNoiseSpectrum(row);
					return;
				}
				if(this.factorMap.size>0){
					this.getNoiseSpectrum(row);
					return;
				}
				getFactorNoise({}).then((res) => {
					
					var factor = res.data.data;
					for (let i = 0; i < factor.length; i++) {
						this.factorMap.set(factor[i].code,factor[i].name);
						this.facList.push(factor[i].code);
					}
					this.getNoiseSpectrum(row);
				});
			},
			getNoiseSpectrum(row){
				let para = {
					mn:this.choosemn,
					starttime:row.starttime,
					time:row.time,
                };
				getNoiseSpectrum(para).then((res) => {
					if(res.data.result=="false"){
                        this.$message({
                            message: "查询出错，请重试",
                            type: 'error'
                        })
						return;
                    }
					var data = res.data.realDatas;
					if(data.length==0){
						return;
					}
					var i=0;
					var _this=this;
					var yData=[];
					var xData=[];
					var facChoose=[];
					_this.facList.forEach(element => {
						var value=data[i][element];
						if(value==null||value==undefined) {
							
						}else{
							yData.push(value);
							facChoose.push(element);
							xData.push(this.factorMap.get(element));
						}
					});
					
					let option = {
						color: ['#66b1ff'],
						tooltip: { trigger: 'axis' },
						xAxis: { data: xData},
						yAxis:  { type: 'value'},
						series:  {  type: 'bar',data: yData }
					}

					_this.charts = echarts.init(document.getElementById("noiseSpectrum"));
					_this.charts.setOption(option);

					var timer=null;
					clearInterval(timer);
					i=1;
					timer=setInterval(function(){
						if(i>=data.length-1){
							clearInterval(timer);
						}
						yData=[];
						facChoose.forEach(element => {
							var value=data[i][element];
							yData.push(value);
						});
						option.series.data=yData;

						_this.charts.setOption(option)
						i++;
					},1000)
				});
			},
			showBar(i,row){
				this.$message({
					message: "功能待开放",
					type: 'warning'
				})
				return;
				this.formVisible=true;
				this.getFactorNoise(row);
			},
			cancleSubmit(){
				this.soundVisible=false;
			},
			addSubmit(){
				let param = new URLSearchParams();
				param.append('soundId', this.soundValue);
				param.append('recordId', this.chooseSound.id);
				param.append('mn', this.chooseSound.mn);
				//开始手动识别
				peopleIdent(param).then((res) => {
					if(res.data.result=="true"||res.data.result==true){
						this.soundVisible=false;
						this.$message({
                            message: "操作成功",
                            type: 'success'
                        })
						this.getDataList();
					}else{
						this.$message({
							message: "操作失败，请重试",
							type: 'error'
						})
					}
				})
			},
			handleCurrentChange(val) {
				this.page=val;
				this.getDataList();
			},
			handleSizeChange(val){
				this.pageSize=val;
				this.getDataList();
			},
			//查询项目信息
			getProjects() {
				this.listLoading = true;
				getProjects().then((res) => {
					this.projects = res.data.data;
					this.listLoading = false;
			        if(this.projects.length>0){
						this.filters.projectId=this.projects[0].projectId;
						this.getDevices();
					}
				});
			},
			//获取设备列表
			getDevices() {
				let para = {
					projectId: this.filters.projectId
                };
				getDevicesByProjectId(para).then((res) => {
					this.devices = res.data.data;
					//如果当前已选的设备不属于选中的项目，把设备置空
					var flag=false;
					if(this.filters.deviceId!=""){
						this.devices.forEach(item => {
							if(item.mnCode==this.filters.mn){
								flag=true;
							}
						});		
					}
					if(!flag&&this.devices.length>0){
						this.filters.mn=this.devices[0].mnCode;
					}
					if(this.firstFlag){
						this.firstFlag=false;
						this.getDataList();
					}
				});
            },
			//获取历史数据信息
			getDataList(){
				this.type=sessionStorage.getItem("type");
				let para = {
					page: this.page,
					pageSize:this.pageSize,
                    mn: this.filters.mn,
					startDate: this.filters.time[0],
					endDate: this.filters.time[1]
				};
				if(this.filters.mn==""){
					this.$message({
						message: "未选择设备",
						type: 'warning'
					})
					return;
				}
				this.listLoading = true;
                queryNoiseRecording(para).then((res) => { 
                    this.handleDataList(res);
                }).catch(() => {
					this.listLoading = false;
				});
			},  
			getSoundList(){
                getSoundTypeList({}).then((res) => { 
					var resdata=res.data;

					if(resdata.result=="true"||resdata.result==true){
						this.soundList=resdata.datas;
					}else{
						this.$message({
							message: "操作失败，请重试",
							type: 'error'
						})
					}
                });
			},  
            //获取历史数据信息
			handleDataList(res){
				this.listLoading = false;
				this.noiseDevice=false;
				this.total = res.data.datas.total;
				this.dataList = res.data.datas.list; 
				this.choosemn=this.filters.mn;
				if(this.dataList.length==0){
					return;
				}
				this.dataList.forEach(element => {
					element.src=window.configuration.resourceUrlJava+element.src;
					// element.src="http://223.99.217.146:10029/"+element.src;
				});

			},
			SetHeight:function(){
				var hgt=document.getElementsByClassName('content-container')[0].clientHeight;
				var titleHgt=document.getElementsByClassName('tags-view-wrapper')[0].clientHeight;
				var toolbarHgt=document.getElementsByClassName('toolbar')[0].clientHeight+document.getElementsByClassName('toolbar')[1].clientHeight;
				this.formHeight=hgt-titleHgt-toolbarHgt-120;

				document.getElementById("dialog").style.height=this.formHeight*0.9+"px";
				document.getElementById("dialog").getElementsByClassName("el-dialog")[0].style.height=this.formHeight*0.8+"px";
			
				
			},
			setTime(){
				var start = new Date();
				// this.filters.time= formatDateDay(start);
				start.setTime(start.setDate(start.getDate()-1));
				var time=formatDateDay(start);
				this.filters.time.push(time);
				var end = new Date();
				this.filters.time.push(formatDateDay(end));
				this.getProjects();
			}
		},
		mounted() {
			var _this=this;
			var timer=null;
			clearInterval(timer);
			timer =setInterval(function(){
				if(_this.formHeight ==0){
					_this.SetHeight();
				}else{
					clearInterval(timer);
				}
			},10)
			
			this.setTime();
		}, 
	}

</script>

<style lang="scss">
	.cell{
		text-align: center;
	}
	.timeFar{
		float: right;
		margin-right: 20px;
	}
	.el-form{
		overflow: hidden;
	}
	.el-col-1{
        text-align: center;
    }

	#dialog .el-dialog{
		height: 100%;
	}
	#dialog .el-dialog__body{
		height: 100%;
	}
	#dialog{
		overflow: hidden;
	}
</style>


// WEBPACK FOOTER //
// SoundSourceIdentification.vue?622d2afa